import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  card: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
    padding: 24,
    borderRadius: 12,
    border: "1px solid #e70017",
    cursor: "pointer",
    backgroundColor: "#fff",
    boxShadow:
      "0px 1px 3px rgba(0,0,0,0.05), 0px 1px 1px rgba(0,0,0,0.06), 0px 2px 1px rgba(0,0,0,0.08)",
  },
  cardTitle: {
    fontSize: 20,
    color: "#000",
    textAlign: "center",
    fontWeight: 400,
    lineHeight: "normal",
  },
  cardDescription: {
    fontSize: 14,
    color: "rgba(26, 26, 26, 0.6)",
    textAlign: "center",
    lineHeight: "20px",
    fontWeight: 400,
  },
}));

export const MetodoCard = ({ icon, title, description, onClick }) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.card}
      onClick={onClick}
    >
      {icon}
      <Typography className={classes.cardTitle}>{title}</Typography>
      <Typography className={classes.cardDescription}>{description}</Typography>
    </Box>
  );
};
